import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GetMessagePublicId, GetMessageResponseId, GetMessagesResponse, ReplyMessageRequest, ReplyMessageResponse } from './interface';
import { STRINGS } from '../../utils/strings';
import { secureStorageUtils } from '../../utils/secureStorageUtils';
import { logout } from '../../utils/authUtils';

export const messageApi = createApi({
  reducerPath: 'messageApi',
  baseQuery: fetchBaseQuery({
    baseUrl: STRINGS.API_URL,
    prepareHeaders: (headers) => {
      const token = secureStorageUtils.getItem("access-token");

      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }

      headers.set("accept", "application/json");
      headers.set("Content-Type", "application/json");
      headers.set("X-CSRF-TOKEN", "");

      return headers;
    },
    validateStatus: (response) => {
      // Handle 401 responses globally
      if (response.status === 401) {
        console.log("401 Unauthorized - logging out user");
        logout(false); // Don't show toast for API-level 401s
      }
      return response.status < 500; // Don't treat 4xx errors as network errors
    },
  }),
  endpoints: (builder) => ({
    getMessages: builder.query<GetMessagesResponse, void>({
      query: () => '/messages',
    }),
    getMessageId: builder.query<GetMessageResponseId, string>({
      query: (id) => `/messages/${id}`,
    }),
    getMessagePublicId: builder.query<GetMessagePublicId, string>({
      query: (id) => `/messages/public/${id}`,
    }),
    replyMessagePublic: builder.mutation<ReplyMessageResponse, ReplyMessageRequest>({
      query: (body) => ({
        url: `/messages/public/reply`,
        method: 'POST',
        body,
      }),
    }),
    updateFirstMessage: builder.mutation<ReplyMessageResponse, { content: string; messageId: string }>({
      query: ({ content, messageId }) => ({
        url: `/messages/${messageId}/update`,
        method: 'PUT',
        body: { content },
      }),
    }),
  }),
})


export const { useGetMessagesQuery, useGetMessageIdQuery, useGetMessagePublicIdQuery, useReplyMessagePublicMutation, useUpdateFirstMessageMutation } = messageApi;
